import React from 'react';
import { Box, Flex, Heading, Text, Link } from 'pounceV2';
import { Link as RRLink } from 'react-router-dom';
import AccessDeniedImg from 'Assets/illustrations/authentication.svg';
import withSEO from 'Hoc/withSEO';
import { LinkButtonV3 } from 'Components/buttons/LinkButton';
import { Permission } from 'Generated/schema';
import useCheckPermissions from 'Hooks/useCheckPermissions';
import useIsLogTypeRBACEnabled from 'Hooks/useIsLogTypeRBACEnabled';
import urls from 'Source/urls';
import { useTheme } from '@mui/material';

const Page403V3: React.FC = () => {
  const canUserAccessSummary = useCheckPermissions(Permission.SummaryRead);
  const isLogTypeRBACEnabled = useIsLogTypeRBACEnabled();
  const theme = useTheme();
  const { tokens, typographyTokens } = theme.palette;

  return (
    <Flex justify="center" align="center" direction="column" mt={6}>
      <Box mb={10}>
        <img alt="Access denied illustration" src={AccessDeniedImg} width="auto" height={400} />
      </Box>
      <Heading variant="h2" fontWeight="medium" mb={2}>
        Oops! You don&apos;t have the proper permissions to view this page.
      </Heading>
      {isLogTypeRBACEnabled ? (
        <Text textAlign="center" my={10} color={tokens.content.text.neutral[2]}>
          This may also be caused by a restriction on the log types you have access to.
          <br />
          Your admin can review these by going to the{' '}
          <Link
            as={RRLink}
            to={urls.settings.roles.list()}
            fontSize={typographyTokens.fontSizes.sm}
          >
            roles page
          </Link>{' '}
          and clicking the <b>Edit</b> option on one of the roles
        </Text>
      ) : (
        <Text mb={10}>
          If you think this is an error, please contact your admin for assistance.
        </Text>
      )}

      {canUserAccessSummary && <LinkButtonV3 to="/">Back to Home</LinkButtonV3>}
    </Flex>
  );
};

export default withSEO({ title: 'Permission Denied' })(Page403V3);
